.container {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;

  @include transition(background-color, opacity);

  &:hover:not(:disabled) {
    background-color: var(--color-grey-light);
  }

  &:active:not(:disabled) {
    background-color: var(--color-grey-light);
    opacity: 0.8;
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary-base);
    outline-offset: 2px;
  }
}

// Size variants
.large {
  width: 38px;
  height: 38px;
  border-radius: map.get($radius, 'md');
}

.medium {
  width: 32px;
  height: 32px;
  border-radius: map.get($radius, 'sm');
}

.small {
  width: 24px;
  height: 24px;
  border-radius: map.get($radius, 'sm');
}

// Type variants
.tertiary {
  // Default - no border (transparent)
}

.outlined {
  border: 1px solid var(--color-grey-neutral);
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;

  &:hover {
    background-color: transparent;
  }
}

.iconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);

  svg {
    width: 100%;
    height: 100%;
  }
}
